import React from 'react';
import { useTranslation } from 'react-i18next';

import { isValidNumber } from '../../../../../../../utils/math/number';
import { TextBox } from '../../../../../text-box/text-box';
import { CollapsableSection } from '../../../components/collapsable-section';

type Props = {
  referenceLength: number;
  setReferenceLength: (value: number) => void;
  setValid: (value: boolean) => void;
};

const minValue = 0.02;

export const ReferenceLengthSection = (props: Props) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = React.useState(true);
  const [valid, setValid] = React.useState(false);
  const [value, setValue] = React.useState(props.referenceLength.toString());

  const onValueChanged = React.useCallback(
    (value: string) => {
      setValue(value);
      const number = Number(value);
      const isValid = isValidNumber(number) && number > minValue;
      props.setReferenceLength(isValid ? number : 0);
      props.setValid(isValid);
      setValid(isValid);
    },
    [props],
  );

  React.useEffect(() => {
    onValueChanged(props.referenceLength.toString());
  }, [props, onValueChanged]);

  return (
    <CollapsableSection
      expanded={expanded}
      title={t('section.referenceLength.text', { ns: 'skyviewScale' })}
      onSetExpanded={(state) => setExpanded(state)}
    >
      <TextBox
        defaultValue={value}
        errorMessage={
          !valid
            ? t('section.referenceLength.inputErrorMessage', {
                ns: 'skyviewScale',
                minLength: minValue,
              })
            : undefined
        }
        type="number"
        onChange={(e) => onValueChanged(e.target.value)}
      />
    </CollapsableSection>
  );
};
